import { Button, ButtonProps } from 'components/ui/button';
import COLORS from 'constants/colors';

export const AppShellButton = (props: ButtonProps) => {
  return (
    <Button
      variant="solid"
      fontSize="md"
      colorPalette="black"
      w="full"
      p="4"
      h="auto"
      fontWeight="500"
      borderRadius="8px"
      borderColor={COLORS.BLACK}
      _focus={{
        boxShadow: `0 0 0 3px ${COLORS.FINCH.PURPLE}`,
        outline: 'none',
      }}
      {...props}
    />
  );
};
